import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";

import { geofenceVehicleSelectSuccess } from "./actions";
import { authApiAccessCheck } from "../auth/actions";

import { GeofenceVehicleSelectBySubscriber } from "../../api-tasks/geofence-changes";
import { GEOFENCE_VEHICLES_SELECT_REQUEST } from "../actions";

function* selectAll({payload}) {
    
    const state = yield select();
    const { history } = payload;
    try {
      const authUser = state.authUser;
      const user = authUser.user;
  
      const resultSet = yield call(GeofenceVehicleSelectBySubscriber, user.userToken);
      
      if (resultSet) {
        if (Array.isArray(resultSet)) {
          yield put(geofenceVehicleSelectSuccess(resultSet));
        } else { 
            yield put(authApiAccessCheck(history, resultSet));
        }
      }
    } catch (error) {
      console.log("error vehicle saga 1 :", error);
    }
  }

  export function* watchSelectAllRequest() {
    yield takeEvery(GEOFENCE_VEHICLES_SELECT_REQUEST, selectAll);
  }

  export default function* rootSaga() {
    yield all([fork(watchSelectAllRequest)]);
  }
